import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
@Pipe({
  name: 'commandIcon'
})
export class CommandIconPipe implements PipeTransform {
  transform(icon: string | ((item?: any) => string), item: GridItem): string {
    if (!icon) {
      return '';
    }
    if (typeof (icon) === 'string') {
      return icon;
    }
    return icon(item);
  }
}
